// extracted by mini-css-extract-plugin
module.exports = {"message":"report-placeholder_message_18fvN","text":"report-placeholder_text_18NJ3","buildButton":"report-placeholder_buildButton_2sfB6"};